import {searchPageModuleName} from 'modules/search-page/slice';
import {useSlice} from 'plugins/hooks/useSlice';

export const useIsSearchContext = () => {
    const slice = useSlice();

    return slice.name === searchPageModuleName;
};
